import { useEffect, useCallback } from 'react';
import { useAudio } from '../contexts/AudioContext';

export function useKeyboardShortcuts() {
  const { togglePlay, changeVolume, toggleMute } = useAudio();

  const handleKeyDown = useCallback((event) => {
    // Don't trigger shortcuts when typing in inputs
    const tagName = event.target.tagName.toLowerCase();
    const isInput = tagName === 'input' || tagName === 'textarea' || event.target.isContentEditable;
    
    if (isInput) return;

    switch (event.code) {
      case 'Space':
        // Spacebar - Play/Pause
        event.preventDefault();
        togglePlay();
        break;
        
      case 'KeyM':
        // M - Toggle mute
        event.preventDefault();
        toggleMute();
        break;
        
      case 'Digit0':
      case 'Numpad0':
        event.preventDefault();
        changeVolume(0);
        break;
        
      case 'Digit1':
      case 'Numpad1':
        event.preventDefault();
        changeVolume(0.1);
        break;
        
      case 'Digit2':
      case 'Numpad2':
        event.preventDefault();
        changeVolume(0.2);
        break;
        
      case 'Digit3':
      case 'Numpad3':
        event.preventDefault();
        changeVolume(0.3);
        break;
        
      case 'Digit4':
      case 'Numpad4':
        event.preventDefault();
        changeVolume(0.4);
        break;
        
      case 'Digit5':
      case 'Numpad5':
        event.preventDefault();
        changeVolume(0.5);
        break;
        
      case 'Digit6':
      case 'Numpad6':
        event.preventDefault();
        changeVolume(0.6);
        break;
        
      case 'Digit7':
      case 'Numpad7':
        event.preventDefault();
        changeVolume(0.7);
        break;
        
      case 'Digit8':
      case 'Numpad8':
        event.preventDefault();
        changeVolume(0.8);
        break;
        
      case 'Digit9':
      case 'Numpad9':
        event.preventDefault();
        changeVolume(0.9);
        break;
        
      default:
        break;
    }
  }, [togglePlay, changeVolume, toggleMute]);

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [handleKeyDown]);

  return {
    shortcuts: [
      { key: 'Space', action: 'Play/Pause' },
      { key: 'M', action: 'Mute/Unmute' },
      { key: '0-9', action: 'Set Volume (0-90%)' }
    ]
  };
}
